<template>
  <div class="market-page  page-padding-top fixed-top fixed">
    <div class="title" v-if="!hideTopBar">{{$t('market.title')}}</div>
    <div class="rankList fixed">
       <div class="table-th flex-center">
          <div class="th flex-3">{{$t('index.label9')}}</div>
          <div class="th flex-2 text-right">{{$t('index.label10')}}(USDT)</div>
          <div class="th flex-2 text-right">{{$t('index.label11')}}</div>
        </div>
       <List
          v-if="marketList.length > 0"
          v-model="loading"
          :finished="finished"
          :finished-text="i18n.t('common.noMore')"
          @load="onLoad">
          <bit-page :dataList="marketList" @detail="toDetail"></bit-page>
       </List>
      </div>
  </div>
</template>

<script>
import { getCoinList, quoteList } from '@/api/index'
import { Button, Search, List, Field } from 'vant';
import bitPage from '@/components/bit'
import { initWebSocket } from '@/utils/common'
export default {
  name: 'about',
  components: {
    Button,
    Search,
    List,
    Field,
    bitPage
  },
  data() {
    return {
      form: {
        keyword: ''
      },
      searchUrl: require('../../assets/imgs/icon-search.png'),
      isInit: false,
      loading: false,
      finished: false,
      page: {
        page: 1,
        limit: 100,
      },
      totalPage: 1,
      marketList: [],
      bitListBak: [],
      searchListBack: [],
      isSearch: false,
      isSearch: false,
      reconnectTimer: null,
      stompClient: null,
      isComponentDestroyed: false,
      webSocket: null,
      quoteListBak: []
    }
  },
  computed: {
    isSend() {
      return this.$store.state.isSend
    },
    bitList() {
      return this.$store.state.bitList
    }
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    this.$store.state.isSend = false
    clearTimeout(this.reconnectTimer)
    this.isComponentDestroyed = true
    if (this.stompClient && this.stompClient.connected) {
      this.$store.state.isClose = true
      this.stompClient.disconnect()
    } else if (this.webSocket && this.webSocket.close) {
      this.$store.state.isClose = true
      this.webSocket.close()
    }
  },
  mounted() {
    this.initHistory()
    this.initCoin()
    this.initSocket()
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  methods: {
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    initCoin() {
      //币种列表
      let list = localStorage.getItem('bitList')
      if (list && list != 'undefined' && this.bitList.length == 0) {
        this.$store.state.bitList = JSON.parse(list)
      } 
      if (this.bitList.length > 0) {
        this.marketList = [].concat(this.bitList).filter(v => {
          return v.Show == 1 && parseFloat(v.Close) > 0
        })
        this.bitListBak = [].concat(this.bitList)
        this.isInit = true
        this.loading = false
      }
      this.init()
    },
    initHistory() {
      quoteList().then(res => {
        this.quoteListBak = res.data
        this.initFirstValue()
      })
    },
    initFirstValue() {
      if (!this.quoteListBak || !this.quoteListBak.length) return
      this.bitListBak.forEach((v, index) => {
        let val = this.quoteListBak.find(item => {
          return item.CurrencyId == v.ID
        })
        if (val) {
          let close = parseFloat(val.Close)
          let open = parseFloat(val.Open)
          let percent = 0
          if (open > 0) {
            percent = parseFloat(((close - open) / open * 100).toFixed(2))
          }
           // Use cached percent if API returns 0 change (Open == Close) but we have history
          if (percent === 0 && v.percent !== 0 && v.percent !== undefined) {
             percent = v.percent
             if (v.Yesterday > 0) {
               open = v.Yesterday
             }
          }
          if (v.ID === 1 || v.ShortName === 'BTC') {
          }
          this.bitListBak[index] = {
            ...this.bitListBak[index],
            Close: close,
            Yesterday: open,
            percent: percent,
            count: close
          }
        }
      })
      if (this.form.keyword) {
        this.searchMarket()
      } else {
        this.marketList = [].concat(this.bitListBak).filter(v => {
          return v.Show == 1 && parseFloat(v.Close) > 0
        })
      }
    },
    init(isAdd) {
      this.loading = true
      getCoinList({
        current: this.page.page,
        pageSize: this.page.limit,
        Status: 1,
      }).then(res => {
        if (res.data.Items) {
          this.totalPage = res.data.Pagination.totalPage
          if (this.totalPage <= this.page.page) {
            this.finished = true
          }
          if (this.totalPage < this.page.page) {
            return
          }
          // Cache lookup
          const cachedMap = new Map();
          try {
            const localCache = localStorage.getItem('bitList');
            if (localCache) {
              const parsedCache = JSON.parse(localCache);
              if (Array.isArray(parsedCache)) {
                parsedCache.forEach(item => {
                  cachedMap.set(String(item.ID), item);
                });
              }
            }
          } catch (e) {
            console.error("[Market Debug] Cache parse error", e);
          }

          let newList = res.data.Items.map(v => {
            // Restore from cache first
            const cached = cachedMap.get(String(v.ID));
            if (cached) {
              v.percent = cached.percent || 0;
              v.Close = cached.Close || 0;
              v.Yesterday = cached.Yesterday || 0;
              v.count = cached.count || 0;
              v.Open = cached.Open || 0;
            } else {
              v.percent = 0
            }

            let val = this.quoteListBak.find(item => {
              return item.CurrencyId == v.ID
            })
            if (val) {
              let close = parseFloat(val.Close)
              let open = parseFloat(val.Open)
              let percent = 0
              if (open > 0) {
                percent = parseFloat(((close - open) / open * 100).toFixed(2))
              }
              // Use cached percent if API returns 0 change (Open == Close) but we have history
              if (percent === 0 && v.percent !== 0 && v.percent !== undefined) {
                 percent = v.percent
                 if (v.Yesterday > 0) {
                   open = v.Yesterday
                 }
              }
              v.Close = close
              v.Yesterday = open
              v.percent = percent
              v.count = close
            }
            return v
          })
          if (isAdd) {
            this.bitListBak = this.bitListBak.concat(newList)
          } else {
            this.bitListBak = newList
          }
          // this.initFirstValue() // No need to call this again, we did it in map
          this.marketList = [].concat(this.bitListBak).filter(v => {
            return v.Show == 1 && parseFloat(v.Close) > 0
          })
         
        }
        this.isInit = true
        this.loading = false
        this.$store.state.bitList = [].concat(this.bitListBak)
        if (this.bitListBak.length > 0) {
          localStorage.setItem('bitList', JSON.stringify(this.bitListBak))
        }
      })
    },
    onLoad() {
      this.page.page += 1
      this.init(true)
    },
    searchMarket() {
      if (!this.form.keyword) {
        if (this.isSearch) {
          this.clearSearch()
        }
        return
      }
      this.finished = true
      this.isSearch = true
      this.marketList = this.bitListBak.filter(v => {
        return v.Name.toLowerCase().indexOf(this.form.keyword) > -1 && v.Show == 1 && parseFloat(v.Close) > 0
      })
    },
    clearSearch() {
      this.isSearch = false
      this.finished = false
      this.marketList = [].concat(this.bitListBak).filter(v => {
        return v.Show == 1 && parseFloat(v.Close) > 0
      })
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        if (!this.stompClient || !this.stompClient.connected) {
          this.initSocket()
        }
      }
    },
    async initSocket(){ //初始化weosocket
      if (this.stompClient && this.stompClient.connected) {
        this.stompClient.disconnect()
      }
      try {
        let client = await initWebSocket('all', this.websocketonmessage, this.websocketonerror)
        if (this.isComponentDestroyed) {
          client.disconnect()
          return
        }
        this.stompClient = client
        this.webSocket = client.ws
      } catch (e) {
        console.error(e)
      }
    },
    websocketonerror(e) {
      if (this.isComponentDestroyed) return
      console.log('socket error', e)
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = setTimeout(() => {
        this.initSocket()
      }, 3000)
    },
    websocketonmessage(e){ //数据接收
      let redata = {}
      try {
        redata = JSON.parse(e.data)
        this.setListData(redata)
      }
      catch(e) {
      }
    },   
    setListData(data) {
      if (!data.tags || !data.fields) return
      let index = this.bitListBak.findIndex(v => {
        return v.ShortName + '-USDT' == data.tags.InstId
      })
      let valObj = data.fields
      
      // Safety check for calculation
      let yesterday = valObj.Yesterday || valObj.Open || 0
      let percent = 0
      if (yesterday > 0) {
        percent = parseFloat(((valObj.Close - yesterday) / yesterday * 100).toFixed(2))
      }
      
      if (yesterday > 0) {
        percent = parseFloat(((valObj.Close - yesterday) / yesterday * 100).toFixed(2))
      }
      
      if (index > -1) {
        this.bitListBak[index] = {
          ...this.bitListBak[index],
          ...valObj,
          percent,
          count: valObj.Close,
        }
      }
      if (this.form.keyword) {
        this.marketList = this.bitListBak.filter(v => {
          return v.ShortName.toLowerCase().indexOf(this.form.keyword) > -1 && v.Show == 1 && parseFloat(v.Close) > 0
        })
      } else {
        this.marketList = [].concat(this.bitListBak).filter(v => {
          return v.Show == 1 && parseFloat(v.Close) > 0
        })
      }
      this.$store.state.bitList = [].concat(this.bitListBak)
      if (this.bitListBak.length > 0) {
        localStorage.setItem('bitList', JSON.stringify(this.bitListBak))
      }
    },
    toDetail(data) {
      this.$router.push({
        name: 'trade',
        query: {
          name: data.ShortName,
          id: data.ID,
          type: 2
        }
      })
    }
  },
}
</script>
<style lang="less">

</style>
